// extracted by mini-css-extract-plugin
export default {"block":"EmptyImage_block__Vrs7k","addImageBlock":"EmptyImage_addImageBlock__lWcBG","icon":"EmptyImage_icon__r2tSm","text":"EmptyImage_text__uobwx"};